import cn from 'classnames';
import React from 'react';
import { t } from '../../../../../utils/i18n';
import * as s from './styles.scss';

export const CardArea: React.FunctionComponent<{
  isSavedCard: boolean;
}> = (props) => (
  <div className={cn(!props.isSavedCard && s.creditCardPayment)}>
    {props.children}
  </div>
);
CardArea.displayName = 'CardArea';

export const CardFormContainer: React.FunctionComponent<{
  isCollapsed: boolean;
}> = (props) => (
  <div
    key="form"
    data-hook="cc-form"
    id="cashier-payments-method-creditCard-iframe-parent"
    className={cn({
      [s.iframeParent]: true,
      [s.noHeight]: props.isCollapsed,
    })}
  >
    {props.children}
  </div>
);
CardFormContainer.displayName = 'CardFormContainer';

export const ErrorMessage: React.FunctionComponent<{
  isSavedCard: boolean;
}> = (props) => (
  <div
    key="error"
    data-hook="cc-error"
    className={cn(!props.isSavedCard && s.creditCardPayment)}
    style={{ minHeight: 'auto' }}
  >
    {t('cc.load.error')}
  </div>
);
ErrorMessage.displayName = 'ErrorMessage';

export const InstallmentsWrapper: React.FunctionComponent<{
  isModalTheme: boolean;
  isCardFormCollapsed: boolean;
}> = (props) => (
  <div
    className={cn(s.installmentsWrap, {
      [s.modalTheme]: props.isModalTheme,
      [s.cardFormCollapsed]: props.isCardFormCollapsed,
    })}
  >
    {props.children}
  </div>
);
InstallmentsWrapper.displayName = 'InstallmentsWrapper';

export const SaveCardCheckboxWrapper: React.FunctionComponent = (props) => (
  <div className={s.saveCreditCardWrap}>{props.children}</div>
);
SaveCardCheckboxWrapper.displayName = 'SaveCardCheckboxWrapper';
